export enum PreviewMap {
  ACTIVE,
  THEORETICAL
}
